import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const emailNotificationsLogAccessRoute: InvariantJiraRoute = {
	name: 'global-admin-helper-email-notifications-log',
	path: '/jira/settings/system/notification-logs',
	exact: true,
};
